import { Store } from '../../core/createStore';
import ProductRepository from '../../service/productRepository';
import OrderRepository from "../../service/orderRepository";
import ProductOrderRepository from "../../service/productOrderRepository";
import OrderProduct from "../../entity/orderProduct";
import Product from "../../entity/product";
import Order from "../../entity/order";

class BuyProduct {
  private orderRepository: OrderRepository;
  private productRepository: ProductRepository;
  private productOrderRepository: ProductOrderRepository;
  private store: Store;

  constructor({
                orderRepository,
                productRepository,
                productOrderRepository,
                store,
              }: {
    orderRepository: OrderRepository;
    productRepository: ProductRepository;
    productOrderRepository: ProductOrderRepository;
    store: Store;
  }) {
    this.orderRepository = orderRepository;
    this.productRepository = productRepository;
    this.productOrderRepository = productOrderRepository;
    this.store = store;
  }

  public async initialize(manageId: string): Promise<{ product: Product, orderProduct: OrderProduct, order: Order }> {
    const session = this.store.getState().currentSession;

    try {
      if (!session) {
        throw new Error('It is cannot have reach here.');
      }
      const order = await this.orderRepository.getOrder(session);
      const product = await this.productRepository.getProduct(session, { manageId });
      const productOrder = await this.productOrderRepository.getProductOrder(session, { orderId: order.id, manageId });

      return { product, orderProduct: productOrder, order };
    } catch (e) {
      throw e;
    }
  }

  public async saveCount(manageId: string, count: number, orderId: string) {
    const session = this.store.getState().currentSession;

    if (!session) {
      throw new Error('It is cannot have reach here.');
    }

    try {
      return await this.productRepository.save(session, { manageId, count, orderId });
    } catch (err) {
      throw err;
    }
  }
}

export default BuyProduct;
